// Template Disclaimer Constants
// These disclaimers are displayed automatically for all code templates

export const TEMPLATE_DISCLAIMER = `Disclaimer:
Indikator Ini adalah alat analisis teknikal yang dibangunkan untuk tujuan pendidikan dan rujukan sahaja.

Ia bukan nasihat pelaburan, cadangan perdagangan, atau jaminan keuntungan dan tidak boleh dianggap sebagai pengganti nasihat daripada penasihat kewangan berlesen.

Keputusan perdagangan adalah tanggungjawab anda sepenuhnya. Penggunaan indikator ini harus disertai dengan analisis menyeluruh, pengurusan risiko yang baik, dan pemahaman tentang pasaran kewangan.

Tiada strategi atau indikator yang 100% tepat. Isyarat yang dihasilkan mungkin menghasilkan false signals, terutama dalam pasaran yang tidak bertrend atau bergejolak.

Anda dinasihatkan supaya menguji strategi ini terlebih dahulu menggunakan akaun demo sebelum berdagang dengan wang sebenar.

Ini membolehkan anda memahami bagaimana indikator berfungsi tanpa risiko kehilangan modal.

Pasaran kewangan melibatkan risiko yang tinggi. Anda boleh kehilangan sebahagian atau seluruh modal anda. Dagang hanya dengan wang yang anda mampu untuk rugi.

Indikator ini bukan produk yang diluluskan atau diawasi oleh Suruhanjaya Sekuriti Malaysia (SC).

Penggunaan indikator ini tidak dikawal selia oleh SC atau mana-mana badan kawal selia kewangan Malaysia.

Pencipta indikator ini tidak bertanggungjawab atas sebarang kerugian, kerosakan, atau akibat kewangan yang timbul daripada penggunaan atau ketidakupayaan untuk menggunakan indikator ini.

Sebelum membuat sebarang keputusan pelaburan atau perdagangan, anda dinasihatkan untuk berunding dengan penasihat pelaburan berlesen dan mematuhi semua peraturan dan garis panduan yang ditetapkan oleh Suruhanjaya Sekuriti Malaysia (SC).

Gunakan dengan bijak dan pada risiko anda sendiri.

Nota: Pastikan anda memahami sepenuhnya risiko yang terlibat dalam perdagangan dan pelaburan.

Jika anda baru dalam perdagangan, pertimbangkan untuk mendapatkan pendidikan dan nasihat profesional sebelum memulakan perdagangan dengan wang sebenar.`;

// Export default object with all disclaimers
export default {
  TEMPLATE_DISCLAIMER
};
